import {
  convertRemToPx,
  type UseBreakpointProps,
} from '@hivebrite/design-system/Theme';

import { HEADINGS_VALUES } from './constants';

export interface HeadingsDefaultStyleProps {
  breakpoint: UseBreakpointProps;
  unit: 'rem' | 'px';
}

// we convert rem to px because we use those in email_renderer
export const headingsDefaultStyle = ({
  breakpoint,
  unit,
}: HeadingsDefaultStyleProps) => {
  const device = ['s', 'xs', 'm'].includes(breakpoint)
    ? 'isMobile'
    : 'isDesktop';

  return `
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: inherit;
      font-family: inherit;
      margin-left: 0;
      margin-right: 0;
    }

    h1 {
      font-size: ${HEADINGS_VALUES[unit][device].h1.fontSize};
      line-height: ${HEADINGS_VALUES[unit][device].h1.lineHeight};
    }

    h2 {
      font-size: ${HEADINGS_VALUES[unit][device].h2.fontSize};
      line-height: ${HEADINGS_VALUES[unit][device].h1.lineHeight};
    }

    h3 {
      font-size: ${HEADINGS_VALUES[unit][device].h3.fontSize};
      line-height:  ${HEADINGS_VALUES[unit][device].h3.lineHeight};
    }
    h4 {
      margin-top: ${convertRemToPx(1.33)}px;
      margin-bottom: ${convertRemToPx(1.33)}px;
    }

    h5 {
      margin-top: ${convertRemToPx(1.67)}px;
      margin-bottom: ${convertRemToPx(1.67)}px;
    }

    h6 {
      margin-top: ${convertRemToPx(2.33)}px;
      margin-bottom: ${convertRemToPx(2.33)}px;
    }

    // We need to override FO/PO style on sup to match the BO style (default style)
    sup {
      vertical-align: super !important;
      font-size: smaller !important;
    }
  `;
};
